import { useState } from 'react';
import { useRouter } from 'next/router';

import CrossIcon from 'icons/CrossIcon';
import ArrowTiltRightIcon from 'icons/ArrowTiltRightIcon';
import { isReferralBannerDismissed, markReferralBannerDismissed } from 'lib/localStorageConstants';
import { ReferralRoutes } from 'routes';

export const isReferralBannerVisible = () => !isReferralBannerDismissed();

type ReferralBannerProps = {
  onVisibilityChange?: (isVisible: boolean) => void;
};

const ReferralBanner = ({ onVisibilityChange }: ReferralBannerProps) => {
  const router = useRouter();
  const [isVisible, setIsVisible] = useState(isReferralBannerVisible);

  const dismiss = () => {
    markReferralBannerDismissed();
    setIsVisible(false);
    onVisibilityChange?.(false);
  };

  const handleReferNow = () => {
    dismiss();
    router.push(ReferralRoutes.Portal);
  };

  if (!isVisible) {
    return null;
  }

  return (
    <div className="relative flex h-9 items-center justify-center bg-neutral-800 px-10">
      <p className="text-sm font-medium text-white">
        Invite your network and start earning.{' '}
        <span className="inline-flex cursor-pointer items-center gap-1 underline" onClick={handleReferNow}>
          Refer now
          <ArrowTiltRightIcon className="h-2.5 w-2.5" stroke="#FFFFFF" />
        </span>
      </p>
      <button
        type="button"
        aria-label="Close referral banner"
        onClick={dismiss}
        className="absolute right-6 top-1/2 -translate-y-1/2 text-neutral-400 hover:text-white"
      >
        <CrossIcon className="h-2.5 w-2.5" />
      </button>
    </div>
  );
};

export default ReferralBanner;
